import $http from '@/api/index';
import store from '@/store';

export default {
  async fetch(id) {
    return $http.get(`/api/board/dayparting/block/${id}`);
  },
  async fetchConfig(id) {
    return $http.get(`/api/board/module/${id}/config`);
  },
  async update(id, payload) {
    payload.context = store.getters.context;
    return $http.patch(`/api/board/dayparting/block/${id}`, payload);
  },
};
